module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-H11NF5HQ6N"],"pluginConfig":{"head":true}},
    }]
